import React, { useContext } from 'react'
import { assessmentsHooks } from '..'
import { AssessmentsContext, tableViewTypes } from '../AssessmentsContext'
import { dataGridModel } from 'keys'
import { AbilityContext } from 'components/Permissions/Can'
import { queryClient as qc } from 'keys'

const useTabs = () => {
    const {
        setDeleteAssessmentsAlertOpen, setOpenMissedAlert, setOpenExecutionAlert, setOpenDuplicateAlert, setShowQuestionAssessments, setOpenCreateBatteryAlert, setOpenStatusAlert, setIsAssignAssessmentAlertOpen, setIsAssignAssessmentAlert2Open,
        assessmentOptions, batteryOptions, setSelectedAssessments, batteries, assessments, page, setPage, batteryPage, setBatteryPage } = useContext(AssessmentsContext)
    const ability = useContext(AbilityContext)

    const batteryColumns = assessmentsHooks.useBatteryColumns()
    const columns = assessmentsHooks.useColumns()
    const collapseColumns = assessmentsHooks.useCollapseColumns()
    const is_superuser = ability.can("manage", "super-user")

    const setRowSelectionModel = (newRowSelectionModel) => {
        setSelectedAssessments(newRowSelectionModel)
    }

    // כשמשנים את הסדר של הטאבים יש לשים לב לעדכן את השורות הבאות כל אחת נמצאת במקום אחר 
    // export const initialTableView = tableViewTypes.battery
    // setTableView(index ? tableViewTypes.single : tableViewTypes.battery)

    return React.useMemo(
        () => [
            {
                id: 0,
                type: tableViewTypes.battery,
                // label: "סוללות מבדקים",
                label: "מבט על",
                width: "80px",
                nestedTable: true,
                columns: batteryColumns,
                nestedColumns: collapseColumns,
                data: batteries,
                loading: batteries.isFetching && !batteries.data,
                page: batteryPage,
                blurred: ({ original }) => original.battery_hidden,
                setPage: (val) => {
                    setBatteryPage(val)
                },
                modelKey: dataGridModel.assessment_battery,
                queryKey: batteryOptions.queryKey,
                onRowSelection: is_superuser ? setRowSelectionModel : false,
                actionBtns: [
                    {
                        label: "שכפול מבדקים עבור יחידת למידה או כיתת אם",
                        action: () => setOpenDuplicateAlert(true)
                    },
                    {
                        label: "עדכן לחלף המועד",
                        action: () => setOpenMissedAlert(true)
                    },
                ]
            },
            {
                id: 1,
                uniqueId: "id",
                type: tableViewTypes.single,
                label: "מבדקים מבודדים",
                columns: columns,
                data: assessments,
                loading: assessments.isFetching && !assessments.data,
                page: page,
                setPage: setPage,
                rowWithBg: true,
                blurred: ({ original }) => original.assessment_hidden,
                modelKey: dataGridModel.assessments,
                onRowSelection: is_superuser ? setRowSelectionModel : false,
                queryKey: assessmentOptions.queryKey,
                actionBtns: [
                    {
                        label: "הצג כולל מבדקי שאלון",
                        action: () => setShowQuestionAssessments(true)
                    },
                    {
                        label: "שיוך מבדקים לסוללה",
                        action: () => setOpenCreateBatteryAlert(true)
                    },
                    {
                        label: "עדכון סטטוס תצוגתי",
                        action: () => setOpenStatusAlert(true)
                    },
                    {
                        label: "שיוך תלמידים ומבדקים לקבוצת למידה",
                        action: () => setIsAssignAssessmentAlertOpen(true)
                    },
                    {
                        label: "שיוך מבדקים לכיתת האם",
                        action: () => setIsAssignAssessmentAlert2Open(true)
                    },
                    {
                        label: "ביטול ביצוע מבדק",
                        action: () => setOpenExecutionAlert("cancel")
                    },
                    {
                        label: "החזר ביצוע מבדק",
                        action: () => setOpenExecutionAlert("restore")
                    },
                    {
                        label: "מחיקת מבדקים",
                        action: () => setDeleteAssessmentsAlertOpen(true)
                    }
                ]
            },
        ],
        [assessments, assessmentOptions, batteries, batteryPage, batteryOptions]
    );

}



export default useTabs
